import {Component, Input, ViewChild} from '@angular/core';
import {ChartOptions, ChartType, Chart, ChartLegendLabelItem} from 'chart.js';

import {BaseChartDirective, Color} from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input()
  public doughnutChartData: number[];
  @Input()
  public chartLabels: string[];
  public doughnutChartType: ChartType = 'doughnut';
  @Input()
  public chartColors: Color[];
  public barChartPlugins = [pluginDataLabels];
  public chartOptions: ChartOptions = {
    tooltips: {
      bodyFontFamily: '"Roboto Mono", monospace',
      bodyFontSize: 14,
      displayColors: false,
      callbacks: {
        label(tooltipItem: Chart.ChartTooltipItem, data: Chart.ChartData): string | string[] {
          let label = data.labels[tooltipItem.index];
          if (typeof label === 'string') {
            label = label.trim();
            // This is ignored because TS-Lint thinks that value doesn't exist on HTML-Element but it does
            // @ts-ignore
            const candidateCount = document.getElementById('candidate-count').value;
            // This is ignored because it doesn't understand that its datatype, but it will always be a number
            // @ts-ignore
            return Math.round(parseInt(candidateCount, 10) * data.datasets[0].data[tooltipItem.index] / 100) + ' ' + label;
          }
          return '';
        },
      }
    },
    legend: {
      onClick(event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) {
        event.stopPropagation();
      },
      position: 'right',
      labels: {
        boxWidth: 13,
        fontFamily: '"Roboto Mono", monospace',
        fontStyle: 'bold',
        fontSize: 10,
        filter(legendItem: Chart.ChartLegendLabelItem, data: Chart.ChartData): any {
          const chartData = [...data.labels];
          chartData.forEach((label: string, index) => {
            chartData[index] = label.toUpperCase();
          });
          const dataIndex = chartData.indexOf(legendItem.text.toUpperCase());
          const dataLength = data.datasets[0].data.length;
          return (dataIndex < dataLength && data.datasets[0].data[dataIndex] > 0) && dataLength >= dataIndex + 1;
        },
        generateLabels: function(chart) {
          const legendLabels: ChartLegendLabelItem[] = [];
          const labels = chart.data.labels;
          labels.forEach((label: string, index) => {
            const item = {
              fillStyle: chart.data.datasets[0].backgroundColor[index],
              lineWidth: 1,
              strokeStyle: 'rgba(0,0,0,0.1)',
              text: label.toUpperCase()
            };
            legendLabels.push(item);
          });
          return legendLabels;
        }
      }
    },
    elements: {
      arc: {
        borderWidth: 0
      },
      rectangle: {
        borderWidth: 0
      }
    },
    plugins: {
      legend: {
        maxWidth: 4,
      },
      datalabels: {
        color: 'white',
        font: {
          family: 'Montserrat',
          weight: 'bold'
        },
        padding: 6,
        formatter: function (value, context) {
          if (value > 0) {
            return value + '%';
          } else {
            return '';
          }
        }
      }
    },
  };

}
